module.exports = __webpack_public_path__ + "components/nearby/static/nearby-location--blue-8622bb6f25012cd0bbed21d9f67f8cb7.svg";